export default __webpack_public_path__ + "static/pattern-1e42c6cabbd1ab8d2b3689dcd116ae26.png";